





















































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { QDialog } from "quasar";

import {} from "googlemaps";

@Component({
  components: {
    AutocompleteInputSearch: () => import("@/components/AutocompleteInputSearch.vue"),
    Map: () => import("@/components/Map.vue"),
  },
})
export default class NewSurveyAddressDialog extends Vue {
  @Ref("new-survey-address-dialog")
  dialog!: QDialog;

  @Prop({ type: String, required: true })
  title!: string;

  search = "";

  center: { lat: number; lng: number } = {
    lat: 43.416667,
    lng: 11,
  };

  selectedPlace: any = null;

  showMap = false;

  mounted() {
    setTimeout(() => {
      this.showMap = true;
    }, 100);
  }

  onSubmit() {
    if (this.selectedPlace) {
      this.$emit("ok", this.selectedPlace);
      this.hide();
    }
  }

  searchTextChange() {
    this.selectedPlace = null;
  }

  onAddressChange(place: google.maps.places.PlaceResult) {
    if (place !== null) {
      if (place.geometry) {
        this.center = place.geometry.location.toJSON();
      }

      this.selectedPlace = {
        ...place,
        geometry: {
          location: place.geometry ? place.geometry.location.toJSON() : null,
          viewport: place.geometry ? place.geometry.viewport.toJSON() : null,
        },
      };
    } else {
      this.selectedPlace = null;
    }
  }

  show() {
    this.dialog.show();
  }

  hide() {
    this.dialog.hide();
  }

  onCancelClick() {
    this.hide();
  }

  onDialogHide() {
    this.$emit("hide");
  }
}
